import { Text, VStack } from '@chakra-ui/react';
import React from 'react';

import Wireframe from '../../wireframe/Wireframe';

/**
 * 実際は画面ではなく，マニュアルPDF (?) へのリンクになっている
 * @returns
 */
const Help = () => {
  return (
    <Wireframe title="HELP">
      <VStack>
        <Text>マニュアルPDFが開く</Text>
      </VStack>
    </Wireframe>
  );
};

export default Help;
